import genericModalStyles from "helpers/genericModalStyles";
import ModalContent from "components/ModalContent";
import LinkButtonGroup from "components/LinkButtonGroup";
import LinkButton from "components/LinkButton";
import Modal from "components/Modal";
import React from "react";

const DefaultModal = ({ closeModal, message }) => (
  <Modal
    contentLabel="Error saving your fundraiser"
    customStyle={genericModalStyles}
    isOpen
    onRequestClose={closeModal}
    shouldCloseOnOverlayClick
  >
    <ModalContent
      action={(
        <LinkButtonGroup>
          <LinkButton
            look="secondary-outline"
            onClick={closeModal}
          >
            Ok
          </LinkButton>
        </LinkButtonGroup>
      )}
      body={(
        <div>
          <p dangerouslySetInnerHTML={{ __html: message }} />
        </div>
      )}
      heading="Error saving your fundraiser"
    />
  </Modal>
);

export default DefaultModal;
